module.exports = __webpack_public_path__ + "static/media/icon_tabulation_l.2554b3eb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/icon/icon_tabulation_l.svg
// module id = 633
// module chunks = 0